export default "__VITE_ASSET__3yHCeU0w__"